<mat-card style="border-color: #5775a8;">
  <mat-card-header class="">
    <div class="flex flex-row rounded-lg w-full" style="background-color:#5775a8; padding: 20px;">
      <mat-icon style="color: white;">settings</mat-icon>
      <span style="font-size: large; color: white;">
        Process Complaint [{{currentComplaint.complaintId}}]
      </span>
    </div>
  </mat-card-header>

  <mat-card-content>
    <br />
    <mat-card>
      <mat-card-header class="flex flex-row rounded-lg w-full" style="padding: 5px;">
        <span>Match with existing business</span> (Initial Business Details)
      </mat-card-header>

      <div class="flex flex-col items-center w-full">
        <br />
        <div class="flex flex-row rounded-lg w-11/12">
          <table class="w-full">
            <tr style="padding-bottom: 10px;">
              <th>Business Name</th>
              <th>Address </th>
              <th>Address 2</th>
              <th>City</th>
              <th>Zip Code</th>
            </tr>
            <tr>
              <td>{{initialComplaint.businessName}}</td>
              <td>{{initialComplaint.address}}</td>
              <td>{{initialComplaint.address2}}</td>
              <td>{{initialComplaint.city}}</td>
              <td>{{initialComplaint.zip}}</td>
            </tr>
            <tr>
              <th>Type of Business</th>
              <th>Phone </th>
              <th>Extension</th>
              <th>County</th>
              <th>Complaint Submitted Date</th>
            </tr>
            <tr>
              <td>{{typeOfBusiness(initialComplaint.typeOfBusiness)}}</td>
              <td>{{initialComplaint.businessPhone}}</td>
              <td>{{initialComplaint.businessPhoneExtension}}</td>
              <td>{{getCounty(initialComplaint.county)}}</td>
              <td>{{currentComplaint.complaintDate}}</td>
            </tr>
            <tr>
              <th>Complaint Text</th>
              <th></th>
              <th></th>
              <th>Complaint Attachments</th>
              <th></th>
            </tr>
            <tr>
              <td colspan="3">
                  {{initialComplaint.complaintComments}}
              </td>
              <td colspan="2">
                <a *ngIf="attachmentCount > 0" (click)="getAttachment(1)">Attachment 1</a>
                <a *ngIf="attachmentCount > 1" (click)="getAttachment(2)">Attachment 2</a>
              </td>
            </tr>

          </table>

        </div>
        <br />
      </div>

    </mat-card>
    <br />

    <mat-card>

      <div *ngIf="!showNext" class="flex flex-col w-full">
        <mat-card-header class="flex flex-row rounded-lg w-full" style="padding: 5px;background-color: #5775a8;">

          <form [formGroup]="form">
            <div class="flex flex-row items-center w-full">
              <div class="flex flex-row rounded-lg w-full" style="padding-left: 20px;">
                <span style="color: white;">Possible Matches from WEMS database 
                  <strong>({{searchList.length}})</strong>.
                </span>
              </div>
              <div class="flex flex-row items-center w-full">
                <div>
                  <mat-form-field class="container" style="padding-right: 20px;">
                    <mat-label>Search Text</mat-label>
                    <input matInput formControlName="searchText" placeholder="Enter search text here">
                  </mat-form-field>
                </div>
                <div>
                  <mat-form-field class="container" style="padding-right: 20px;">
                    <mat-label>County</mat-label>
                    <mat-select formControlName="countyId">
                      <mat-option value="All">All</mat-option>
                      <mat-option *ngFor="let list of countyList" [value]="list.value">
                        {{list.text}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div>
                  <button mat-raised-button (click)="getSearchBusinessData()" class="m-8" style="background: #7ABDF3;">
                    <span>
                      Update Results
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </form>
          <!-- </div> -->
        </mat-card-header>
        <br />
        <mat-card-content>
          <div class="flex flex-col w-full">
            <div *ngIf="searchList.length == 0" class="flex flex-col rounded-lg w-full"
              style="padding:20px; background-color: lightpink;">
              <div class="alert alert-danger">
                <span style="color: red;">
                  No matches were found for <strong>{{searchText}}</strong> in the WEMS complaints database.<br /><br />
                  Use the <i style="color: blue;"> I can't find a suitable business.</i> feature below to create a new
                  business
                  <br /><strong>or</strong> <br />
                  Use the form above to refine the search results.
                </span>
              </div>


            </div>

            <div *ngIf="searchList.length > 0" class="flex flex-col rounded-lg w-11/12">

              <div class="flex flex-col w-full" style="overflow-x:auto;">
                <div class="flex flex-row w-full">
                  <div class="flex w-3/4">
                  </div>
                  <div class="flex flex-row w-1/4 rounded-lg justify-end">
                    <input (keyup)="filterTable($event)" placeholder="Search" [value]="filter" />
                  </div>
                </div>
                <div class="flex flex-row w-full">

                  <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #MatSort="matSort"
                    class="w-full">

                    <ng-container matColumnDef="id">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Business Id</th>
                      <td mat-cell *matCellDef="let business">
                        <mat-radio-button (click)="radioChange(business.id)">{{business.id}}</mat-radio-button>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="businessName">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                      <td mat-cell *matCellDef="let business">{{business.businessName}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="businessAddress1">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
                      <td mat-cell *matCellDef="let business">
                        {{business.businessAddress1}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="businessCity">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
                      <td mat-cell *matCellDef="let business">{{business.businessCity}}</td>
                    </ng-container>
                    <ng-container matColumnDef="businessZip">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Zip</th>
                      <td mat-cell *matCellDef="let business">{{business.businessZip}}</td>
                    </ng-container>
                    <ng-container matColumnDef="countyName">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>County</th>
                      <td mat-cell *matCellDef="let business">{{getCounty(business.countyId)}}</td>
                    </ng-container>
                    <ng-container matColumnDef="active">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Active</th>
                      <td mat-cell *matCellDef="let business">
                        <span *ngIf="business.active" style="color: green;">Yes</span>
                        <span *ngIf="!business.active" style="color: red;">No</span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="exempt">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Exempt</th>
                      <td mat-cell *matCellDef="let business">
                        <span *ngIf="business.exempt" style="color: green;">Yes</span>
                        <span *ngIf="!business.exempt" style="color: red;">No</span>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>

                  </table>

                </div>
                <mat-paginator [pageSizeOptions]="[25, 100]" #TablePaginator="matPaginator"
                  showFirstLastButtons></mat-paginator>
              </div>
              <div>
                <button mat-raised-button (click)="next()" class="m-8" style="background: green;">
                  <mat-icon style="color: white;">arrow_right</mat-icon>
                  <span style="color: white;">Associate Complaint with Business</span>
                </button>
              </div>
            </div>
            <div>
              <mat-checkbox [(ngModel)]="newBusinessFlag" (change)="cantFindBusiness($event)">
                <span>I can't find a suitable business</span>
              </mat-checkbox>
            </div>
          </div>
        </mat-card-content>
      </div>

      <div *ngIf="showNext" class="flex flex-col w-full">
        <mat-card-content>
          <div class="flex flex-col w-full">
            <div class="flex flex-col rounded-lg w-full" style="padding:20px; background-color: lightpink;">
              <div class="flex flex-row w-full">
                <strong style="color:red">You have chosen to associate the above entered business with the existing
                  business below.</strong>
              </div>
              <div class="flex flex-col items-center w-full">
                <br />
                <div class="flex flex-row rounded-lg w-11/12">
                  <table class="w-full">
                    <tr style="padding-bottom: 10px;">
                      <th><span style="color: red;">Business ID</span></th>
                      <th><span style="color: red;">Name</span></th>
                      <th><span style="color: red;">Address</span></th>
                      <th><span style="color: red;">City</span></th>
                      <th><span style="color: red;">Zip</span></th>
                      <th><span style="color: red;">County</span></th>
                      <th><span style="color: red;">Active</span></th>
                      <th><span style="color: red;">Exempt</span></th>
                    </tr>
                    <tr style="background-color: white;">
                      <td style="text-align: center;"><span style="color: red;">{{selectedBusiness.id}}</span></td>
                      <td><span style="color: red;">{{selectedBusiness.businessName}}</span></td>
                      <td><span style="color: red;">{{selectedBusiness.businessAddress1}}</span></td>
                      <td><span style="color: red;">{{selectedBusiness.businessCity}}</span></td>
                      <td><span style="color: red;">{{selectedBusiness.businessZip}}</span></td>
                      <td><span style="color: red;">{{getCounty(selectedBusiness.countyId)}}</span></td>
                      <td>
                        <span *ngIf="selectedBusiness.active" style="color: green;">Yes</span>
                        <span *ngIf="!selectedBusiness.active" style="color: red;">No</span>
                      </td>
                      <td>
                        <span *ngIf="selectedBusiness.exempt" style="color: green;">Yes</span>
                        <span *ngIf="!selectedBusiness.exempt" style="color: red;">No</span>
                      </td>
                    </tr>

                  </table>

                </div>
                <br />
                <!-- </div> -->
              </div>

              <div class="flex flex-row w-full">
                <div>
                  <button mat-raised-button (click)="associate()" class="m-8" style="background: green;">
                    <span style="color: white;">Associate</span>
                  </button>
                </div>
                <div>
                  <button mat-raised-button (click)="cancel()" class="m-8">
                    <span>Cancel</span>
                  </button>
                </div>
              </div>

            </div>

          </div>
        </mat-card-content>
      </div>

    </mat-card>

  </mat-card-content>
</mat-card>